import { Text } from "atoms/typography";
import { appUserSelectNone } from "lib/app/styles";
import { colors } from "lib/theme";
import styled from "styled-components";
import {
  color,
  fontSize,
  fontWeight,
  lineHeight,
  space,
  textAlign,
} from "styled-system";

export const LegacyLabel = styled.label`
  ${appUserSelectNone}
  ${fontSize};
  ${space};
  ${color};
  ${fontWeight};
  ${lineHeight};
  ${textAlign};
  display: block;

  ${(p) => p.disabled && `color: ${colors.gray[600]};`}
`;
LegacyLabel.defaultProps = {
  color: colors.navy[500],
  fontSize: 12,
  lineHeight: [20 / 12, 22 / 16],
  p: ["0px 4px", "2px 12px"],
  // TODO: no 500 weight yet
  fontWeight: 500,
  textAlign: "left",
};

const Label = (props) => (
  <Text
    display="block"
    as="label"
    fontSize="xs"
    color="#5F758B"
    fontWeight="medium"
    lineHeight={16 / 12}
    pb={[1, , 3]}
    w="100%"
    {...props}
  />
);

export default Label;
